webpackJsonp([1],{

/***/ "ANZ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"bottom"}},[_c('a',{attrs:{"id":"pause"},on:{"click":_vm.pauseFun}},[_vm._v(_vm._s(!_vm.paused ? '暂停动画' : '继续动画 ||'))]),_vm._v(" "),_c('a',{attrs:{"id":"skipAnimation"},on:{"click":_vm.skipAnimationFun}},[_vm._v("跳过动画")]),_vm._v(" "),_c('p',_vm._l((_vm.demourl),function(url,index){return _c('span',{key:index},[_c('a',{attrs:{"href":url.url}},[_vm._v(_vm._s(url.title))])])}),0),_vm._v(" "),_c('div',{class:_vm.playing ? 'rotate' : '',attrs:{"id":"music"},on:{"click":_vm.musicPause}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BgRM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'bottom',
    data: function data() {
        return {
            demourl: [{
                url: 'http://eveningwater.com/',
                title: '个人网站'
            }, {
                url: 'https://github.com/eveningwater',
                title: 'github'
            }],
            paused: false, //暂停
            playing: false, //播放图标动画
            autoPlaying: false, //播放音频
            audio: ''
        };
    },
    mounted: function mounted() {},

    methods: {
        // 创建音频
        createAudio: function createAudio() {
            this.audio = new Audio();
            this.audio.loop = 'loop';
            this.audio.autoplay = 'autoplay';
            this.audio.src = "http://eveningwater.com/project/newReact-music-player/audio/%E9%BB%84%E5%9B%BD%E4%BF%8A%20-%20%E7%9C%9F%E7%88%B1%E4%BD%A0%E7%9A%84%E4%BA%91.mp3";
        },

        // 播放音乐
        playMusic: function playMusic() {
            this.playing = true;
            this.autoPlaying = true;
            // 创建audio标签
            if (!this.audio) {
                this.createAudio();
            } else {
                this.audio.load();
            }
        },

        // 跳过动画
        skipAnimationFun: function skipAnimationFun(e) {
            e.preventDefault();
            this.$emit('on-skip');
        },

        // 暂停动画
        pauseFun: function pauseFun(e) {
            e.preventDefault();
            this.paused = !this.paused;
            this.$emit('on-pause', this.paused);
        },

        // 暂停音乐
        musicPause: function musicPause() {
            this.playing = !this.playing;
            if (!this.playing) {
                this.audio.pause();
            } else {
                this.audio.play();
            }
        }
    }
});

/***/ }),

/***/ "Jf4x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"code",domProps:{"innerHTML":_vm._s(_vm.codeInstyleTag)}}),_vm._v(" "),_c('div',{ref:"container",staticClass:"styleEditor",attrs:{"contenteditable":"true"},domProps:{"innerHTML":_vm._s(_vm.highlightedCode)},on:{"blur":function($event){return _vm.updateCode($event)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ffb6020_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("PUAj");
function injectStyle (ssrContext) {
  __webpack_require__("jKNv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ffb6020"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ffb6020_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");



/* eslint-disable no-new */
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: "history"
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: "#app",
  router: router,
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  }
});

/***/ }),

/***/ "Or+o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marked__ = __webpack_require__("EFqf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_marked__);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['markdown', 'enableHtml'],
	name: 'ResumeEditor',
	computed: {
		result: function result() {
			return this.enableHtml ? __WEBPACK_IMPORTED_MODULE_0_marked___default()(this.markdown) : this.markdown;
		}
	},
	methods: {
		goBottom: function goBottom() {
			this.$refs.container.scrollTop = 10000;
		}
	}
});

/***/ }),

/***/ "PUAj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"slide"}},[(_vm.isDown)?_c('div',{staticClass:"header"},[_c('label',{staticClass:"w-inter-text"},[_vm._v("写字速度:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.speed),expression:"speed"},{name:"number",rawName:"v-number"}],staticClass:"w-inter-input",attrs:{"type":"text","placeholder":"请输入1到100的整数数字"},domProps:{"value":(_vm.speed)},on:{"input":function($event){if($event.target.composing){ return; }_vm.speed=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"w-inter-btn",attrs:{"type":"button"},on:{"click":_vm.updateSpeed}},[_vm._v("修改速度")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"down",style:({ top: _vm.isDown ? '50px' : '15px'}),on:{"click":function($event){_vm.isDown = !_vm.isDown}}}),_vm._v(" "),_c('div',{staticClass:"main",style:(_vm.isDown ? ' height:calc(100% - 40px);' : '')},[_c('StyleEditor',_vm._b({ref:"styleEditor"},'StyleEditor',_vm.currentStyle,false,true)),_vm._v(" "),_c('ResumeEditor',{ref:"resumeEditor",attrs:{"markdown":_vm.currentMarkdown,"enableHtml":_vm.enableHtml}})],1),_vm._v(" "),_c('BottomNav',{ref:"bottomNav",on:{"on-pause":_vm.pauseAnimation,"on-skip":_vm.skipAnimation}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QFLD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_styleEditor_vue__ = __webpack_require__("cO61");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9288056_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_styleEditor_vue__ = __webpack_require__("Jf4x");
function injectStyle (ssrContext) {
  __webpack_require__("oSr1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e9288056"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_styleEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9288056_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_styleEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Xmob":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bottomNav_vue__ = __webpack_require__("BgRM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72b8f506_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bottomNav_vue__ = __webpack_require__("ANZ+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bottomNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72b8f506_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bottomNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZsCP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cO61":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__("OEdS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Editor',
	props: ['code'],
	computed: {
		highlightedCode: function highlightedCode() {
			//代码高亮
			return __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlight(this.code, __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.languages.css);
		},
		// 让代码生效
		codeInstyleTag: function codeInstyleTag() {
			return '<style>' + this.code + '</style>';
		}
	},
	methods: {
		goBottom: function goBottom() {
			this.$refs.container.scrollTop = 10000;
		},
		updateCode: function updateCode(e) {
			this.$emit('update:code', e.target.textContent);
		}
	}
});

/***/ }),

/***/ "gjYM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resumeEditor_vue__ = __webpack_require__("Or+o");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_294f3cb9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_resumeEditor_vue__ = __webpack_require__("lVEg");
function injectStyle (ssrContext) {
  __webpack_require__("yvKw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-294f3cb9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resumeEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_294f3cb9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_resumeEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jDg9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var fullStyle = ["/*\n* \u5927\u5BB6\u597D,\u6211\u53EB\u5915\u6C34(eveningwater),\n* \u662F\u4E00\u4E2Aweb\u524D\u7AEF\u5F00\u53D1\u5DE5\u7A0B\u5E08,\n* \u8FD9\u662F\u4E00\u4E2A\u6211\u4E3A\u81EA\u5DF1\u800C\u5199\u7684\u7B80\u5386.\n* \u8BA9\u6211\u4EEC\u4E00\u8D77\u6765\u770B\u770B\u5427.\n*/\n/* \u9996\u5148\u7ED9\u52A8\u753B\u52A0\u4E0A\u8FC7\u6E21\u6548\u679C*/\nbody,html{\n\ttransition:all .5s;\n}\n/* \u8FC7\u6E21\u6548\u679C\u52A0\u4E0A\u4E86,\u4F46\u662F\u4F60\u5E76\u6CA1\u6709\u770B\u5230\u5565,\n* \u662F\u4E0D\u662F\u554A?\n* \u4E0D\u8981\u7740\u6025,\u7EE7\u7EED\u5F80\u4E0B\u770B\u5C31\u662F\u4E86:\n* \u8FC7\u6E21\u6548\u679C\u53EA\u662F\u4E3A\u4E86\u8BA9\u52A8\u753B\u66F4\u987A\u7545\u4E00\u70B9\u7F62\u4E86.\n* \u5148\u6539\u53D8\u80CC\u666F\u989C\u8272,\u6BD5\u7ADF\u767D\u8272\u80CC\u666F\u592A\u5355\u8C03\u4E86\u4E0D\u662F\u5417?\n*/\nhtml,html{\n\tbackground-color:#abb1b1;\n}\n/*\n* \u7B49\u5F85\u6240\u6709\u7684\u5B57\u4F53\u90FD\u53D8\u6210\u767D\u8272...\n*/\nbody,html{\n\tcolor:#fff;\n}\n/*\n* \u4F46\u662F\u5C31\u8FD9\u6837,\u80AF\u5B9A\u8FD8\u8FDC\u8FDC\u4E0D\u591F,\u55EF,\n* \u6211\u5C31\u52A0\u4E2A\u7F16\u8F91\u5668,\n* \u7528\u4E8E\u88C5css\u4EE3\u7801\u7684,\n* \u5C06\u8FD9\u4E9B\u4EE3\u7801\u90FD\u88C5\u5728\u8FD9\u91CC\u9762\n*/\n.styleEditor{\n\twidth:45%;\n\theight:77vh;\n\tbackground:#202120;\n\tborder:1px solid #f2f2f2;\n}\n/*\n* \u7F16\u8F91\u5668\u5199\u597D\u4E86,\u4F46\u662F\u5B57\u4F53\u989C\u8272\u5168\u662F\u767D\u8272,\n* \u662F\u4E0D\u662F\u592A\u8FC7\u5355\u8C03\u4E86\u4E9B?\n* \u522B\u7740\u6025,\u6211\u9A6C\u4E0A\u628A\u4EE3\u7801\u9AD8\u4EAE\u6548\u679C\u6DFB\u52A0\u4E0A,\n* \u7EE7\u7EED......\n*/\n.token.comment{color:#b4b4b4;font-family:italic;}\n.token.selector{ color: #de8322; }\n.token.property{ color: #a230ea; }\n.token.punctuation{ color: #29e354;}\n.token.function{ color: #de32b0;}\n/*\n* \u4EE3\u7801\u9AD8\u4EAE\u6548\u679C\u6DFB\u52A0\u4E86,\u4F46\u662F\u6211\u53D1\u73B0\u8FD9\u4E2A\u7F16\u8F91\u5668,\n* \u8FD9\u6837\u770B\u7740\u597D\u6CA1\u610F\u601D,\n* \u55EF,\u52A0\u70B93D\u6548\u679C,\u8BA9\u5B83\u770B\u4E0A\u53BB\u50CF\u7ACB\u4F53\u6A21\u5F0F\u4E00\u6837......\n*/\n.main,.resumeEditor{\n\tperspective:1000px;\n}\n/*\n* \u8FD9\u53EA\u662F\u5F00\u542F\u4E863D\u6A21\u5F0F,\u8981\u8BA9\u5B83\u770B\u4E0A\u53BB\u6709\u79CD\u7ACB\u4F53\u611F,\n* \u8FD8\u5F97\u52A0\u70B9\u52A8\u753B......\n*/\n.styleEditor{\n\tposition:absolute;\n\tright:7%;\n\ttop:0;\n\ttransition:none;\n\ttransform:rotateY(-10deg) translateZ(100px);\n}\n/*\n* \u6211\u628A\u6EDA\u52A8\u6761\u7684\u6837\u5F0F\u4E5F\u8BBE\u7F6E\u4E00\u4E0B.\n*/\n::-webkit-scrollbar{\n\twidth: 0;\n}\n/*\n* \u55EF,\u8FD9\u4E2A\u7F16\u8F91\u5668\u770B\u6765\u662F\u6CA1\u5565\u95EE\u9898\u4E86,\u4F46\u662F,\n* \u6211\u89C9\u5F97\u597D\u50CF\u5C11\u4E86\u70B9\u4EC0\u4E48......\n* \u54E6,\u5BF9\u8FD8\u5C11\u4E86\u53E6\u4E00\u4E2A\u7F16\u8F91\u5668,\u6BD5\u7ADF\u662F\u4E00\u4E2A\u7B80\u5386\u7F51\u9875,\n* \u5F97\u628A\u6211\u7684\u7B80\u5386\u5199\u4E0A\u5427.\n* \u597D\u5427,\u63A5\u4E0B\u6765,\u6211\u5C31\u518D\u5199\u4E00\u4E2A\u7F16\u8F91\u5668.\n*/\n.resumeEditor{\n\tposition:absolute;\n\tleft:0;\n\ttop:0;\n\twidth:45%;\n\theight:93vh;\n\tbackground-color:#202120;\n\ttransform:rotateY(10deg) translateZ(-100px);\n}\n/*\n* \u7F16\u8F91\u5668\u5199\u597D\u4E86,\u5F00\u59CB\u5F80\u91CC\u9762\u5199\u5185\u5BB9,\u6211\u5F00\u59CB\u4ECB\u7ECD\u6211\u81EA\u5DF1\u4E86......\n*/\n", "\n/*\n* \u5BF9\u4E86\u8FD9\u4E2A\u7B80\u5386,\u597D\u50CF\u8FD8\u5DEE\u70B9\u5565.\n* \u55EF,\u8FD9\u53EA\u662F\u4E00\u4E2A\u6587\u672C\u4ECB\u7ECD,\u6211\u9700\u8981\u628A\u4ED6\u6253\u9020\u6210HTML\u9875\u9762\u7C7B\u578B.\n* \u7528\u4E00\u4E2A\u7F16\u8BD1\u5DE5\u5177markdown\u7F16\u8BD1\u4E00\u4E0B\n* \u597D\u4E86,\u6210\u529F\u4E86.\n*/\n", "\n/*\n* \u6211\u5148\u628A\u8FD9\u4E2A\u7F16\u8F91\u5668\u8C03\u6574\u4E00\u4E0B.\n* \u518D\u6DFB\u52A0\u70B9\u6837\u5F0F.\n*/\n.resumeEditor{\n\tpadding:2em;\n}\n.resumeEditor h2{\n\tdisplay:inline-block;\n\tborder-bottom:1px solid;\n\tmargin:1em 0 .5em;\n}\n.resumeEditor ul,.resumeEditor ol{\n\tlist-style:none;\n}\n.resumeEditor ul > li::before{\n\tcontent:\" \";\n\tmargin-right:.5em;\n}\n.resumeEditor ol{\n\tcounter-reset:section;\n}\n.resumeEditor ol li::before{\n\tcounter-increment:section;\n\tcontent:counters(section,'.') \" \";\n\tmargin-right:.5em;\n}\n.resumeEditor blockquote{\n\tmargin: 1em;\n\tpadding: .5em;\n}\n/* \u4F46\u662F\u8FD9\u8D85\u94FE\u63A5\u770B\u7740\u4E0D\u723D,\n* \u6211\u6539\u7F8E\u89C2\u4E00\u4E9B,\n*/\n.resumeEditor a{\n\ttext-decoration:none;\n\tcolor:#bf862d;\n}\n.resumeEditor a:hover,\n.resumeEditor a:active{\n\tcolor:#2396ff;\n}\n/*\n* \u52A8\u753B\u52A0\u8F7D\u5B8C\u6210\u4E86.\n* \u6682\u505C\u548C\u8DF3\u8FC7\u52A8\u753B\u6309\u94AE\u4E5F\u5F97\u79FB\u9664\u6389.....\n*/\n#pause,#skipAnimation{\n\tdisplay:none;\n}\n/*\n* \u5F53\u7136\uFF0C\u4F60\u8FD8\u53EF\u4EE5\u81EA\u5DF1\u7F16\u8F91\u6837\u5F0F\u3002\n* \u6BD4\u5982\uFF0C\u6211\u628A\u9875\u9762\u7684\u80CC\u666F\u6362\u4E0B\n* \n*/\nbody,html{\n\tbackground-color:#f2f2f2;\n}\n/*\n* \u6700\u540E,\u6211\u60F3\u542C\u9996\u6B4C\u653E\u677E\u653E\u677E\u4E0B.\n* \u6B4C\u540D:<\u771F\u7231\u4F60\u7684\u4E91>\n* \u6B4C\u624B:\u9EC4\u56FD\u4FCA\n* \u5148\u52A0\u4E2A\u6309\u94AE\u63A7\u5236\u97F3\u4E50\u7684\u6682\u505C\u548C\u64AD\u653E.\n*/\n#music{\n\tdisplay:block;\n}\n/*\n* \u51C6\u5907\u597D......\n* 3...\n* 2...\n* 1...\n* \u97F3\u4E50\u5F00\u59CB......\n*/"];
/* harmony default export */ __webpack_exports__["a"] = (fullStyle);

/***/ }),

/***/ "jKNv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lVEg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"resumeEditor",class:{htmlMode:_vm.enableHtml}},[(_vm.enableHtml)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.result)}}):_c('pre',[_vm._v(_vm._s(_vm.result))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oSr1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rX/x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var fullMarkdown = "* \u5915\u6C34(eveningwater),\n* \u76EE\u524D\u5728\u6210\u90FD\u5DE5\u4F5C\n-----\n\u6280\u80FD\n-----\n* \u719F\u6089\u524D\u7AEF\u5F00\u53D1\n* \u9AD8\u6548\u7684\u81EA\u5B66\u80FD\u529B\n-----\n\u5DE5\u4F5C\u9879\u76EE\n-----\n1. [\u4E2A\u4EBA\u7F51\u7AD9](http://eveningwater.com/)\n2. [\u5927\u5E08\u6709\u7A7A](http://api.soulside.cn/masterv3_web_formal/public/wap/wapmaster/dist/#/?id=1)\n3. [\u9633\u5149\u52A9\u5B66\u7CFB\u7EDF](http://help.qianjiang.kunyueyun.com/#/)\n4. [\u56ED\u533A\u670D\u52A1\u7CFB\u7EDF](http://pss.kunyueyun.com/#/login)\n5. [\u4F01\u4E1A\u5E94\u7528\u7CFB\u7EDF](http://pes.kunyueyun.com/#/login)\n6. [\u5546\u5BB6\u670D\u52A1\u7CFB\u7EDF](http://bss.kunyueyun.com/#/login)\n7. [\u56ED\u533A\u5B98\u7F51(\u65E7\u7248)](http://park.kunyueyun.com/#/login)\n8. [\u56ED\u533A\u5B98\u7F51(\u65B0\u7248)](http://www.kunyueyun.com/)\n9. [\u6367\u573A\u5BA2\u540E\u53F0\u7BA1\u7406\u7CFB\u7EDF](http://www.pengchangke.com.cn/admin/#/)\n10. [\u9886\u68B5\u540E\u53F0](https://h5.ledfin.cn)\n11. \u76F8\u5173APP\u9875\u9762\u82E5\u5E72\n12. \u9886\u68B5\u5C0F\u7A0B\u5E8F\n13. [17\u7D20\u6750](http://www.17sucai.com/pins/26618.html)\n-----\n\u5176\u5B83\u7231\u597D\n-----\n* \u8BD7\u8BCD(\u4E3B\u8981\u53D1\u8868\u5728\u4EE5\u4E0B\u7F51\u7AD9):\n* [\u4E2D\u56FD\u8BD7\u6B4C\u7F51](http://www.zgshige.com/c/2016-11-07/2029387.shtml)\n* [\u8BD7\u8BCD\u5728\u7EBF](http://www.chinapoesy.com/gongxianglist894225B7-3462-42F6-8B0D-118B36FF31D8.html)\n-----\n* \u5B8C\u7ED3\u5C0F\u8BF4(\u5DF2\u4E0A\u7EBF)\n* [\u9AD8\u624B\u6765\u90FD\u5E02](http://www.zhujiange.com/book/57433/index.html),\u867D\u7136\u5199\u7684\u6BD4\u8F83\u70C2,\u54C8\u54C8\u54C8\u54C8\u54C8!\n-----\n> \u5982\u679C\u4F60\u559C\u6B22\u8FD9\u4E2A\u6548\u679C\u7684\u8BDD,\u6B22\u8FCE\u4E0B\u8F7D[\u6E90\u7801](https://github.com/eveningwater/vue-resume)\u7814\u7A76\u3002";
/* harmony default export */ __webpack_exports__["a"] = (fullMarkdown);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_resumeEditor__ = __webpack_require__("gjYM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_styleEditor__ = __webpack_require__("QFLD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_bottomNav__ = __webpack_require__("Xmob");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_common_css__ = __webpack_require__("ZsCP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_common_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_common_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_js__ = __webpack_require__("jDg9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__my_js__ = __webpack_require__("rX/x");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    components: {
        ResumeEditor: __WEBPACK_IMPORTED_MODULE_3__components_resumeEditor__["a" /* default */],
        StyleEditor: __WEBPACK_IMPORTED_MODULE_4__components_styleEditor__["a" /* default */],
        BottomNav: __WEBPACK_IMPORTED_MODULE_5__components_bottomNav__["a" /* default */]
    },
    directives: {
        // 只允许输入数字
        number: {
            inserted: function inserted(el, binding, vnode) {
                el.oninput = function (e) {
                    if (isNaN(Number(e.target.value)) || Number(e.target.value) > 100 || Number(e.target.value) < 1) {
                        e.target.value = vnode.context.speed = '';
                        return;
                    }
                };
            }
        }
    },
    data: function data() {
        return {
            interval: 50, //写入字的速度
            speed: 50,
            currentStyle: {
                code: ''
            },
            enableHtml: false, //是否打造成HTML网页
            fullStyle: __WEBPACK_IMPORTED_MODULE_7__style_js__["a" /* default */],
            currentMarkdown: '',
            fullMarkdown: __WEBPACK_IMPORTED_MODULE_8__my_js__["a" /* default */],
            timer: null,
            isDown: false
        };
    },
    created: function created() {
        this.makeResume();
    },
    mounted: function mounted() {},

    methods: {
        updateSpeed: function updateSpeed() {
            this.interval = this.speed;
        },

        // 暂停动画
        pauseAnimation: function pauseAnimation(bool) {
            if (bool && this.timer) {
                clearTimeout(this.timer);
            } else {
                this.makeResume();
            }
        },

        // 快速跳过动画
        skipAnimation: function skipAnimation() {
            var _this = this;

            if (this.timer) {
                clearTimeout(this.timer);
            }
            var str = '';
            this.fullStyle.map(function (f) {
                str += f;
            });
            setTimeout(function () {
                _this.$set(_this.currentStyle, 'code', str);
            }, 100);
            this.currentMarkdown = __WEBPACK_IMPORTED_MODULE_8__my_js__["a" /* default */];
            this.enableHtml = true;
            this.$refs.styleEditor.goBottom();
            this.$refs.bottomNav.playMusic();
        },

        // 加载动画
        makeResume: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _this2 = this;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.writeShowStyle(0);

                            case 2:
                                _context.next = 4;
                                return this.writeShowResume();

                            case 4:
                                _context.next = 6;
                                return this.writeShowStyle(1);

                            case 6:
                                _context.next = 8;
                                return this.writeShowHtml();

                            case 8:
                                _context.next = 10;
                                return this.writeShowStyle(2);

                            case 10:
                                _context.next = 12;
                                return this.$nextTick(function () {
                                    _this2.$refs.bottomNav.playMusic();
                                });

                            case 12:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function makeResume() {
                return _ref.apply(this, arguments);
            }

            return makeResume;
        }(),
        // 打造成HTML网页
        writeShowHtml: function writeShowHtml() {
            var _this3 = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                _this3.enableHtml = true;
                resolve();
            });
        },
        // 写入css代码
        writeShowStyle: function writeShowStyle(n) {
            var _this5 = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var showStyle = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                    var _this4 = this;

                    var style, length, prefixLength, l, char;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    style = this.fullStyle[n];

                                    if (style) {
                                        _context2.next = 3;
                                        break;
                                    }

                                    return _context2.abrupt('return');

                                case 3:
                                    //计算出数组每一项的长度
                                    length = this.fullStyle.filter(function (f, i) {
                                        return i <= n;
                                    }).map(function (it) {
                                        return it.length;
                                    }).reduce(function (t, c) {
                                        return t + c;
                                    }, 0);
                                    //当前要写入的长度等于数组每一项的长度减去当前正在写的字符串的长度

                                    prefixLength = length - style.length;

                                    if (this.currentStyle.code.length < length) {
                                        l = this.currentStyle.code.length - prefixLength;
                                        char = style.substring(l, l + 1) || ' ';

                                        this.currentStyle.code += char;
                                        if (style.substring(l - 1, l) === '\n' && this.$refs.styleEditor) {
                                            this.$nextTick(function () {
                                                _this4.$refs.styleEditor.goBottom();
                                            });
                                        }
                                        this.timer = setTimeout(showStyle, this.interval);
                                    } else {
                                        resolve();
                                    }

                                case 6:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, this);
                })).bind(_this5);
                showStyle();
            });
        },

        // 写入简历
        writeShowResume: function writeShowResume() {
            var _this6 = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var length = _this6.fullMarkdown.length;
                var showResume = function showResume() {
                    if (_this6.currentMarkdown.length < length) {
                        _this6.currentMarkdown = _this6.fullMarkdown.substring(0, _this6.currentMarkdown.length + 1);
                        var lastChar = _this6.currentMarkdown[_this6.currentMarkdown.length - 1];
                        var prevChar = _this6.currentMarkdown[_this6.currentMarkdown.length - 2];
                        if (prevChar === '\n' && _this6.$refs.resumeEditor) {
                            _this6.$nextTick(function () {
                                _this6.$refs.resumeEditor.goBottom();
                            });
                        }
                        _this6.timer = setTimeout(showResume, _this6.interval);
                    } else {
                        resolve();
                    }
                };
                showResume();
            });
        }
    }
});

/***/ }),

/***/ "yvKw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.2e6163b0ad7ce60b3c34.js